import { Entity } from './Entity'

class Campus extends Entity {
  constructor (
    id = null,
    name = null,
    referent = null,
    mainSite = null,
    country = null,
    area = null,
    citySize = null,
    latitude = Entity.DEFAULT_LATITUDE,
    longitude = Entity.DEFAULT_LONGITUDE,
    type = null,
    domains = []
  ) {
    super(
      id,
      name,
      referent,
      mainSite,
      country,
      area,
      citySize,
      latitude,
      longitude
    )
    this.type = type
    this.domains = domains
  }

  toDatabase () {
    return {
      type: 'Campus',
      data: {
        id: this.id,
        name: this.name,
        // don't export referent
        // referent: this.referent,
        mainSite: this.mainSite,
        country: this.country,
        area: this.area,
        citySize: this.citySize,
        domains: this.domains,
        type: this.type,
        latitude: this.latitude,
        longitude: this.longitude
      }
    }
  }

  toString (sep = '\t') {
    return [
      this.id,
      this.name,
      this.type,
      this.domains.map((obj) => obj.name + ':' + obj.percentage).join(';'),
      this.mainSite,
      this.country,
      this.area
    ].join(sep)
  }

  static get ICON () {
    return 'graduation-cap'
  }

  static createEmpty () {
    return new Campus()
  }

  static createFromObj (item) {
    return new Campus(
      item.id,
      item.name,
      item.referent,
      item.mainSite,
      item.country,
      item.area,
      item.citySize,
      item.latitude,
      item.longitude,
      item.type,
      item.domains
    )
  }

  static exportHeader (sep = '\t') {
    return [
      'entity.id',
      'entity.name',
      'entity.type',
      'entity.domains',
      'entity.city',
      'entity.country',
      'entity.region'
    ].join(sep)
  }
}

export { Campus }
